import {useId, useState} from "react";
import {Button} from "@/primitives/Button";
import {FA6Icon} from "@/primitives/FA6Icon";
import {Label} from "@/primitives/Label";
import {RadioGroup, RadioGroupItem} from "@/primitives/Radio";
import {api} from "@/shared/api";
import {applyAppearance, type AppearancePreference} from "@/shared/appearance";
import {Notify} from "@/shared/ui/notify";
import styles from "./appearancePanel.module.css";

const appearanceOptions = ["system", "light", "dark"] as const;

export function AppearancePanel({preference}: {preference: AppearancePreference}) {
	const titleId = useId();
	const descriptionId = useId();
	const [selected, setSelected] = useState(preference);
	const [saved, setSaved] = useState(preference);
	const [saving, setSaving] = useState(false);

	const save = () => {
		const value = selected;
		setSaving(true);
		api("changeUserSetting.json").post({propertyName: "webAppearance", value})
			.done(() => {
				setSaved(value);
				Notify.success(messages["user.settings.appearance.saved"]);
			})
			.always(() => setSaving(false));
	};

	return (
		<div className="panel panel-flat">
			<div className="panel-heading">
				<h5 id={titleId} className="panel-title">{messages["user.settings.appearance.title"]}</h5>
			</div>
			<div className="panel-body">
				<p id={descriptionId} className="text-muted">{messages["user.settings.appearance.description"]}</p>
				<div className={styles.controls}>
					<RadioGroup value={selected} onValueChange={(value: AppearancePreference) => {
						setSelected(value);
						applyAppearance(value);
					}}
					            aria-labelledby={titleId} aria-describedby={descriptionId} className={styles.options}>
						{appearanceOptions.map(value => (
							<Label key={value} className={styles.option}>
								<RadioGroupItem value={value}/>
								{messages[`user.settings.appearance.${value}`]}
							</Label>
						))}
					</RadioGroup>
					<Button onClick={save} disabled={saving || selected === saved}>
						<FA6Icon icon="floppy-disk" variant="regular" fixedWidth className="mr-5"/>
						{messages["dialog.save"]}
					</Button>
				</div>
			</div>
		</div>
	);
}
